import React from 'react';

export function Tag({selected=false,onClick,onRemove,style,children,...rest}){
  const [hover,setHover]=React.useState(false);
  const s={display:'inline-flex',alignItems:'center',gap:'var(--space-3)',height:30,padding:'0 var(--space-4)',borderRadius:'var(--radius-pill)',fontFamily:'var(--font-text)',fontSize:'var(--fs-xs)',fontWeight:'var(--fw-medium)',cursor:onClick?'pointer':'default',transition:'var(--transition-control)',
    background:selected?'var(--surface-brand)':'var(--white)',color:selected?'var(--white)':'var(--text-body)',
    border:'1px solid '+(selected?'var(--surface-brand)':'var(--border-default)'),
    ...(hover&&!selected?{borderColor:'var(--rose-400)',background:'var(--rose-50)'}:null),...style};
  return React.createElement('span',{style:s,onClick,onMouseEnter:()=>setHover(true),onMouseLeave:()=>setHover(false),...rest},
    children,
    onRemove?React.createElement('span',{onClick:e=>{e.stopPropagation();onRemove(e);},style:{cursor:'pointer',opacity:.6,fontSize:14,lineHeight:1}},'\u00d7'):null);
}
